module.exports = __webpack_public_path__ + "img/sapodilla-350x184.898467af.jpg";